type EventType = 'completed' | 'live' | 'upcoming' | 'none';

// From WordPress
export interface YouTubeVideoWordpress {
  id: number;
  video_id: string; // "7vz-RwImK40",
  status: EventType; // "upcoming",
  title: string; // "Benzinga Live",
  published_at: string; // "2022-04-29 20:33:37",
  channel_id: string; // "UCqQs28K2zj2dOsc5NfXUKEg",
  description: string; // "GET 25% OFF BENZINGA PRO👉https://benzinga.grsm.io/benzingalive\r\n\r\n🚨The Fintwit Conference is around the corner! Use code BZYOUTUBE20 for 20% off tickets https://www.benzinga.com/events/fintwit2022/🚨\r\n\r\nTODAY’S GUESTS\r\n\r\n\r\nHOSTS\r\n\r\nSpencer Israel\r\nTwitter: https://twitter.com/sjisrael\r\n\r\nAaron Bry\r\nTwitter: https://twitter.com/aaronbry5\r\n\r\n💰Get $50 in FREE Bitcoin when you use the code ZING on Voyager👉https://voyager.onelink.me/ujgO/8c34df17💰\r\n\r\nPRO TOOLS:\r\n📈pro.benzinga.com\r\n✅Free 2 week trial, no credit card required✅\r\n🙌Use coupon code YOUTUBE20 to get 20% off🙌\r\n\r\nWEBSITE & SOCIALS:\r\n💻 Website: https://www.benzinga.com\r\n👍Benzinga on Instagram & Facebook @ Benzinga\r\n🛎Benzinga on TikTok & Twitter @ Benzinga\r\n📺Benzinga on Discord: https://discord.com/invite/Sy2UgMPu6u\r\n\r\nMAKE MONEY, BECOME A BENZINGA AFFILIATE:\r\n♻️Earn 30% commission on new subscriptions♻️\r\n💰https://benzinga.partnerstack.com/💰\r\n\r\nMERCH:\r\n👕https://swag.benzinga.com/\r\n\r\nSTART MAKING MONEY, LEARN HOW TO INVEST:\r\n💰https://www.benzinga.com/money/investing/\r\n\r\nBEST ONLINE BROKERS:\r\n🟣https://benzinga.com/money/online-stock-trading/\r\n🟣https://benzinga.com/money/best-brokers-cryptocurrencies/\r\n💰Mutual Funds\r\n💰Penny Stocks\r\n💰Short Sellers\r\n💵Forex Trading\r\n\r\nBENZINGA’s CORE BUSINESSES:\r\n✅Financial news articles: http://benzinga.com\r\n✅Real-time news headlines: http://pro.benzinga.com\r\n✅Financial, Market, and Alternative data APIs: http://cloud.benzinga.com\r\n✅The Benzinga Global Fintech Awards: http://benzingafintechawards.com\r\n\r\nDisclaimer: All of the information, material, and/or content contained in this program is for informational purposes only. Investing in stocks, options, futures, and crypto is risky and not suitable for all investors. Please consult your own independent financial adviser before making any investment decisions.\r\n\r\n#Benzinga #BenzingaLive #BenzingaPro",
  num_views: number | null; // 0,
  num_likes: number | null; // 3,
  num_dislikes: number | null; // null,
  num_comments: number | null; // 0,
  tags: string[];
  created_at: string; // "2022-04-30 17:29:08",
  updated_at: string; // "2022-04-30 17:35:44",
  contentDetails: {
    duration: string; // "P0D",
    dimension: string; // "2d",
    definition: string; // "sd",
    caption: string; // "false",
    licensedContent: boolean; // false,
    projection: string; // "rectangular"
  };
  liveStreamingDetails: {
    scheduledStartTime: string; // "2022-05-02T15:30:00Z",
    activeLiveChatId: string; // "Cg0KCzd2ei1Sd0ltSzQwKicKGFVDcVFzMjhLMnpqMmRPc2M1TmZYVUtFZxILN3Z6LVJ3SW1LNDA"
  };
}

export interface YoutubeChannel {
  id: number;
  youtube_id: string;
  title: string;
}

export interface FeaturedVideos {
  recent: YouTubeVideoWordpress[];
  live: YouTubeVideoWordpress[];
  upcoming: YouTubeVideoWordpress[];
}

export interface VideosResponse extends FeaturedVideos {
  channel: YoutubeChannel;
}

// Common interfaces
interface PageInfo {
  totalResults: number;
  resultsPerPage: number;
}

// /videos endpoint response
export interface YouTubeVideoListResponse {
  kind: 'youtube#videoListResponse';
  etag: string;
  nextPageToken?: string;
  prevPageToken?: string;
  pageInfo: PageInfo;
  items: YouTubeVideo[];
}

interface PageInfo {
  totalResults: number;
  resultsPerPage: number;
}

interface Thumbnail {
  url: string;
  width?: number;
  height?: number;
}

interface Thumbnails {
  default?: Thumbnail;
  medium?: Thumbnail;
  high?: Thumbnail;
  standard?: Thumbnail;
  maxres?: Thumbnail;
}

enum LiveBroadcastContent {
  Live = 'live',
  Upcoming = 'upcoming',
  None = 'none',
}

enum UploadStatus {
  Deleted = 'deleted',
  Failed = 'failed',
  Processed = 'processed',
  Rejected = 'rejected',
  Uploaded = 'uploaded',
}

enum PrivacyStatus {
  Private = 'private',
  Public = 'public',
  Unlisted = 'unlisted',
}

export interface YouTubeVideo {
  kind: 'youtube#video';
  etag: string;
  id: string;
  snippet?: {
    publishedAt: string;
    channelId: string;
    title: string;
    description: string;
    thumbnails: Thumbnails;
    channelTitle: string;
    tags?: string[];
    categoryId: string;
    liveBroadcastContent: LiveBroadcastContent;
    defaultLanguage?: string;
    localized?: {
      title: string;
      description: string;
    };
    defaultAudioLanguage?: string;
  };
  contentDetails?: {
    duration: string;
    dimension: '2d' | '3d';
    definition: 'hd' | 'sd';
    caption: 'true' | 'false';
    licensedContent: boolean;
    regionRestriction?: {
      allowed?: string[];
      blocked?: string[];
    };
    contentRating: Record<string, string>;
    projection: 'rectangular' | '360';
  };
  status?: {
    uploadStatus: UploadStatus;
    failureReason: string;
    rejectionReason: string;
    privacyStatus: PrivacyStatus;
    publishAt: string;
    license: string;
    embeddable: boolean;
    publicStatsViewable: boolean;
  };
  statistics?: {
    viewCount: string;
    likeCount: string;
    dislikeCount: string;
    favoriteCount: string;
    commentCount: string;
  };
  player?: {
    embedHtml: string;
    embedHeight?: number;
    embedWidth?: number;
  };
  topicDetails?: {
    topicIds: string[];
    relevantTopicIds: string[];
    topicCategories: string[];
  };
  recordingDetails?: {
    recordingDate: string;
  };
  fileDetails?: {
    fileName: string;
    fileSize: string;
    fileType: string;
    container: string;
    videoStreams: Array<{
      widthPixels: number;
      heightPixels: number;
      frameRateFps: number;
      aspectRatio: number;
      codec: string;
      bitrateBps: string;
      rotation: string;
      vendor: string;
    }>;
    audioStreams: Array<{
      channelCount: number;
      codec: string;
      bitrateBps: string;
      vendor: string;
    }>;
    durationMs: string;
    bitrateBps: string;
    creationTime: string;
  };
  processingDetails?: {
    processingStatus: string;
    processingProgress: {
      partsTotal: string;
      partsProcessed: string;
      timeLeftMs: string;
    };
    processingFailureReason: string;
    fileDetailsAvailability: string;
    processingIssuesAvailability: string;
    tagSuggestionsAvailability: string;
    editorSuggestionsAvailability: string;
    thumbnailsAvailability: string;
  };
  suggestions?: {
    processingErrors: string[];
    processingWarnings: string[];
    processingHints: string[];
    tagSuggestions: Array<{
      tag: string;
      categoryRestricts: string[];
    }>;
    editorSuggestions: string[];
  };
  liveStreamingDetails?: {
    actualStartTime: string;
    actualEndTime: string;
    scheduledStartTime: string;
    scheduledEndTime: string;
    concurrentViewers: string;
    activeLiveChatId: string;
  };
}

// /playlistItems endpoint response
export interface YouTubePlaylistItemListResponse {
  kind: 'youtube#playlistItemListResponse';
  etag: string;
  nextPageToken?: string;
  prevPageToken?: string;
  pageInfo: PageInfo;
  items: YouTubePlaylistItem[];
}

export interface YouTubePlaylistItem {
  kind: 'youtube#playlistItem';
  etag: string;
  id: string;
  snippet: {
    publishedAt: string;
    channelId: string;
    title: string;
    description: string;
    thumbnails: Thumbnails;
    channelTitle: string;
    videoOwnerChannelTitle: string;
    videoOwnerChannelId: string;
    playlistId: string;
    position: number;
    resourceId: {
      kind: string;
      videoId: string;
    };
  };
  contentDetails: {
    videoId: string;
    startAt?: string;
    endAt?: string;
    note?: string;
    videoPublishedAt: string;
  };
  status: {
    privacyStatus: PrivacyStatus;
  };
}

export interface FormattedVideoItem {
  href: string;
  id: string;
  image: string;
  title: string;
}

export type YoutubeClearCacheAction = 'resetAll' | 'resetKey' | 'resetPattern' | 'getKeys' | 'getStats';

export interface YouTubeClearCacheParams {
  action: YoutubeClearCacheAction;
  keys?: string[];
  pattern?: string;
}
